import React, { Fragment, useState } from "react";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import { FILTER_LIST, GUEST_ROUTES, PAGE_LIST } from "../../../routes/PageList";
import { usePage, router } from '@inertiajs/react';
import { NavigationButton } from "./NavigationButton";
import useStore from "../../../states/store";
import { FilterTagsDialog } from "./filter/FilterTagsDialog";
import { COLLAB_KEY, CREATOR_ROLE, PENDING_CREATOR_ROLE, SPECIAL_POPULAR_TAGS } from "../../../enums/generalEnums";
import { capitalizeFirstLetter } from "../../../helpers/stringHelper";
import { FilterByLocationDialog } from "./filter/FilterByLocationDialog";

export const SideBarContent = ({ userDetails }) => {
  const { auth } = usePage().props;
  const [{ popularTag }, { setCreatorFilters, setPopularTag, hasPermission, setSignUpDialogState, setLoginDialogState }] = useStore();
  const [openFilterAllTagsDialog, setOpenFilterAllTagsDialog] = useState(false);
  const [openFilterByLocationDialog, setOpenFilterByLocationDialog] = useState(false);
  const { url } = usePage();
  const pathName = new URL(url, window.location.origin).pathname;

  const handleOpenFilterAllTags = () => {
    setOpenFilterAllTagsDialog(true);
  };

  const handleSelectFilter = (key) => {
    if (key === COLLAB_KEY) {
      router.visit('/');
      setPopularTag(COLLAB_KEY);
    } else {
      if (key === 'Location') {
        setOpenFilterByLocationDialog(true);
      } else {
        if (SPECIAL_POPULAR_TAGS?.TAGS?.includes(capitalizeFirstLetter(key))) {
          const filterTag = SPECIAL_POPULAR_TAGS?.[key];
          setCreatorFilters(filterTag);
        } else {
          setCreatorFilters({ category_values: key });
        }
        router.visit(`/collab-creators`);
        setPopularTag(key);
      }
    }
  };

  return (
    <Box sx={{ padding: '0px 10px 0 24px' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', overflowX: 'auto', height: { sm: '84vh', md: '84vh', lg: '87vh' }, paddingRight: '10px' }}>
        <Stack direction={'column'} justifyContent={'center'} alignItems={'center'} gap={1.5}>
          {
            (GUEST_ROUTES.includes(pathName)) ?
              <Fragment>
                <Typography variant="h6" color="primary.main" fontWeight={700}>POPULAR TAGS</Typography>
                {
                  FILTER_LIST?.map((filter, index) => {
                    const isActive = (popularTag === filter?.filterKey);
                    return (
                      <NavigationButton
                        key={`filter-key-${index}`}
                        page={filter}
                        isActive={isActive}
                        customIcon={filter?.icon ? false : true}
                        onClick={() => handleSelectFilter(filter?.filterKey)}
                      />
                    );
                  })
                }
              </Fragment> : <Fragment>
                <Typography variant="h6" color="primary.main" fontWeight={700} width={250} noWrap textAlign={'center'}>
                  {(userDetails?.user?.role === CREATOR_ROLE || userDetails?.user?.role === PENDING_CREATOR_ROLE) ? userDetails?.user?.name : <span style={{ textTransform: 'uppercase' }}>{userDetails?.user?.role}</span>}
                </Typography>
                {
                  PAGE_LIST?.map((page, index) => {
                    const isActive = (url === page?.path);
                    return hasPermission(page?.permission) && <NavigationButton key={`page-key-${index}`} page={page} isActive={isActive} onClick={() => router.visit(page?.path)} />;
                  })
                }
              </Fragment>
          }
        </Stack>
        <Stack gap={2} mt={3}>
          {
            (GUEST_ROUTES.includes(pathName)) && <Fragment>
              <Button variant="contained" sx={{ color: '#FFF', p: '10px 0', fontWeight: 600 }} onClick={() => handleOpenFilterAllTags()}>Filter All Tags</Button>
              <Box sx={{ backgroundColor: 'background.lightBlue', padding: '16px 12px', borderRadius: '10px' }}>
                <Stack alignItems={'center'}>
                  <img src="/logos/teasy-logo.png" style={{ height: '25px', marginBottom: 2 }} />
                  <Typography variant="body2" fontWeight={500} textAlign={'center'} mb={1.5}>Looking for an OnlyFans Agency? <br></br>Check Teasy now!</Typography>
                  <Button variant="outlined" fullWidth onClick={() => window.open('https://teasyagency.com/', '_blank')}>Visit Teasy</Button>
                </Stack>
              </Box>
            </Fragment>
          }
          <Divider />
          <Box sx={{ padding: '0 24px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <Typography textAlign={'center'} variant={'body2'} sx={{ cursor: 'pointer' }} color="primary" fontWeight={500} onClick={() => router.visit('/contact-us')}>
              Contact Us
            </Typography>
            <Stack direction={'row'} justifyContent={'space-between'}>
              <Typography variant={'body2'} sx={{ cursor: 'pointer' }} color="primary" fontWeight={500} onClick={() => router.visit('/privacy-policy')}>
                Privacy Policy
              </Typography>
              <Typography variant={'body2'} sx={{ cursor: 'pointer' }} color="primary" fontWeight={500} onClick={() => router.visit('/terms-and-conditions')}>
                Terms of Service
              </Typography>
            </Stack>
            {
              (!auth?.user) && <Stack direction={'row'} alignItems={'center'} justifyContent={'center'} gap={1.5} margin={'10px 0'}>
                <Typography textAlign={'center'} variant={'body2'} sx={{ cursor: 'pointer' }} color="primary" fontWeight={500} onClick={() => setLoginDialogState(true)}>
                  Login
                </Typography>
                <Divider orientation="vertical" variant="middle" />
                <Typography textAlign={'center'} variant={'body2'} sx={{ cursor: 'pointer' }} color="primary" fontWeight={500} onClick={() => setSignUpDialogState(true)}>
                  Sign Up
                </Typography>
              </Stack>
            }
            <Typography variant="body2" textAlign={'center'} color="grey.dark">Copyright © 2024 WannaCollab. <br></br>All Rights Reserved.</Typography>
          </Box>
        </Stack>
        <FilterTagsDialog
          openFilterAllTagsDialog={openFilterAllTagsDialog}
          handleCloseFilterAllTags={() => setOpenFilterAllTagsDialog(false)}
        />
        <FilterByLocationDialog
          openFilterLocationDialog={openFilterByLocationDialog}
          handleClose={() => setOpenFilterByLocationDialog(false)}
        />
      </Box>
    </Box>
  );
};